// extracted by mini-css-extract-plugin
export var blok_content = "index-module--blok_content--2c6c8";
export var btn_container = "index-module--btn_container--8b722";
export var cards_layout = "index-module--cards_layout--dcee0";
export var edit_share_card = "index-module--edit_share_card--5ecf6";
export var features_list = "index-module--features_list--7fd59";
export var format_item = "index-module--format_item--3a466";
export var format_list = "index-module--format_list--c47d2";
export var format_title = "index-module--format_title--9c996";
export var format_title_list_container = "index-module--format_title_list_container--92cea";
export var pic_container = "index-module--pic_container--5b69f";
export var short_format_title = "index-module--short_format_title--77a3b";
export var support_format = "index-module--support_format--061ab";
export var text_container = "index-module--text_container--4e139";
export var text_pic_container = "index-module--text_pic_container--dcc71";
export var trans_workspace_card_cover = "index-module--trans_workspace_card_cover--f94c9";
export var trans_workspace_container = "index-module--trans_workspace_container--54d4d";
export var trans_workspace_content = "index-module--trans_workspace_content--fa36e";